import { useMemo } from 'react';
import RefreshRoundedIcon from '@material-ui/icons/RefreshRounded';

import { SButton, SEmptyState } from '@setvi/shared/components';

import { EmptyContainer } from '../../styled';

interface NoSalesEnablementProps {
  metadataError?: boolean;
  errorCode?: number;
  disabled?: boolean;
  onRetry?: () => void;
}

const NoSalesEnablement = ({
  metadataError,
  // @ts-ignore
  errorCode,
  disabled,
  onRetry
}: NoSalesEnablementProps) => {
  const subTitle = useMemo(() => {
    if (disabled)
      return `This Sales Kit is currently undergoing additional quality checks to ensure you have the best possible materials. Our support team will reach out to you once it is available. Thank you for your patience!`;

    if (!metadataError)
      return `Sales Kit content is currently unavailable for this product. Please try again in 10-15 mins. Our technical team has been notified and will follow up as well`;

    return 'We apologize, but in some instances, sales enablement information may not be available for the product.';
  }, [metadataError, disabled]);

  return (
    <EmptyContainer>
      <SEmptyState
        imageSrc={
          !metadataError
            ? '/images/empty/generation-failed.png'
            : '/images/empty/no-results.png'
        }
        imageAlt="Empty Content"
        title={
          disabled
            ? 'Sales Kit Temporarily Unavailable'
            : 'AI Sales Kit Unavailable'
        }
        subTitle={subTitle}
        additionalContent={
          !metadataError &&
          onRetry && (
            <SButton
              variant="outlined"
              startIcon={
                <RefreshRoundedIcon
                  style={{
                    marginBottom: 2
                  }}
                />
              }
              style={{
                marginTop: 16,
                borderRadius: 120
              }}
              onClick={onRetry}>
              Retry
            </SButton>
          )
        }
      />
    </EmptyContainer>
  );
};

export default NoSalesEnablement;
